import { render, staticRenderFns } from "./ModalAprovarRecusarValorAdicional.vue?vue&type=template&id=0d93fd77&"
import script from "./ModalAprovarRecusarValorAdicional.vue?vue&type=script&lang=ts&"
export * from "./ModalAprovarRecusarValorAdicional.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VSpacer,VTextarea})
